module.exports = __webpack_public_path__ + "img/Jimenez2022.117e03b5.jpg";